export type RtuDetailViewMode = 'basic' | 'detailed' | 'actions';

export const normalizeRequestedRtuDetailView = (value: string | null | undefined): RtuDetailViewMode => {
  if (value === 'actions') return 'actions';
  if (value === 'detailed' || value === 'enhanced') return 'detailed';
  return 'basic';
};

export const resolveRtuDetailViewMode = (
  requestedView: string | null | undefined,
  _canUseDetailedView = true
): RtuDetailViewMode => {
  return normalizeRequestedRtuDetailView(requestedView);
};
